import { render, staticRenderFns } from "./weaponTransferSearchedResult.vue?vue&type=template&id=4547c71c&scoped=true"
import script from "./weaponTransferSearchedResult.vue?vue&type=script&lang=js"
export * from "./weaponTransferSearchedResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547c71c",
  null
  
)

export default component.exports